import { useState, useEffect } from 'react'
import { CheckBox } from 'devextreme-react/check-box';
import { IoCartOutline } from 'react-icons/io5'
import { RxCross2 } from "react-icons/rx";
import { CapitalizeFirstLowercaseRest, ConvertPriceToString } from '../../../Helpers/CustomConverter';
import { useCart } from '../../../Providers/CartProvider';
import useGetProductIndexWithMask from '../../../Components/BasketPage/Hooks/useGetProductIndexWithMask';
import { FaRegEdit } from 'react-icons/fa'
import { FaCheck } from "react-icons/fa6";
import { useSavedBaskets } from '../../../Providers/SavedBasketsProvider';
import { toast } from 'react-toastify';
import useAddProductsToSavedBasket from '../../../Components/BasketPage/Hooks/useAddProductsToSavedBasket';
import { handleInputForQtyAndValueFocus, handleOnChangeForQtyAndValueInput } from '../../../Helpers/PriceAndValueInputHelpers';
import { useNavigate } from 'react-router-dom';

const SavedBasketTabTableContent = ({ basket, isCheckedParam, handleDeleteSavedBasketFunc, handleCheckUncheckBasket, setMessageModalFunctionTyp, setShowQuestionAboutReplaceBasket,
    handleMessageModalResult, setIsLoading
}) => {
    const navigate = useNavigate()
    const [isChecked, setIsChecked] = useState(isCheckedParam)
    const [showBasketItems, setShowBasketItems] = useState(false)
    const { cartItems, getBasketTotalValue } = useCart()
    const { getProductIndexWithMask } = useGetProductIndexWithMask()
    const [isEditMode, setIsEditMode] = useState(false)
    const { setSavedBaskets, setSelectedSavedBasket, deleteProductFromSavedBasket, changeSavedBasketName } = useSavedBaskets()
    const { handleEditProductsInSavedBasket } = useAddProductsToSavedBasket()
    const [initialSavedBasket, setInitialSavedBasket] = useState(basket) //DK do resetu danych po edycji X
    const [isBasketNameEdit, setIsBasketNameEdit] = useState(false)
    const [basketName, setBasketName] = useState(basket.name)

    useEffect(() => {
        setSelectedSavedBasket(null)
    }, [])

    useEffect(() => {
        if (isEditMode) {
            setIsChecked(false)
            handleCheckUncheckBasket(basket, false)
        }
    }, [isEditMode])

    const handleSaveChanges = async (isReject) => {
        if (isReject) {
            setSavedBaskets(prev => {
                return prev.map(sb => {
                    if (sb.basketId === basket.basketId) {
                        return initialSavedBasket
                    }
                    return sb
                })
            })
        }
        else {
            setIsLoading(true)
            const editedBasket = await handleEditProductsInSavedBasket(basket.basketId, basket.basketItems)
            if (editedBasket) {
                setSavedBaskets(prev => {
                    return prev.map(sb => {
                        if (sb.basketId === basket.basketId) {
                            return editedBasket
                        }
                        return sb
                    })
                })
                setInitialSavedBasket(editedBasket)
                toast.success('Pomyślnie zaktualizowano szybko koszyk')
            }
            else {
                toast.error('Nie udało się zaktualizować szybkokoszyka')
            }
            setIsLoading(false)
        }
        setIsEditMode(false)
    }

    const handleDeleteProductFromSavedBasket = async (item) => {
        if (basket.basketItems.length == 1) {
            toast.warning('Nie możesz usunąć wszystkich pozycji z szybkokoszyka!')
            return
        }

        const res = await deleteProductFromSavedBasket(basket.basketId, item.artNo)

        if (res) {
            setSavedBaskets(prevSavedBaskets => {
                return prevSavedBaskets.map(singleBasket => {
                    if (singleBasket.basketId === basket.basketId) {
                        const newBasketItems = singleBasket.basketItems.filter(
                            basketItem => basketItem.artNo !== item.artNo
                        )

                        const itemsForCalculation = newBasketItems.map(bi => {
                            const realCostNet = Number(bi.costNet) || bi.product?.priceNet || 0
                            let realTaxRate = bi.product?.taxRate || 0
                            if (realTaxRate == 0 && bi.product?.priceGross > 0 && bi.product?.priceNet > 0) {
                                realTaxRate = (bi.product.priceGross / bi.product.priceNet) - 1
                            }
                            return {
                                ...bi,
                                costNet: realCostNet,
                                product: { ...bi.product, taxRate: realTaxRate }
                            }
                        })

                        const totals = getBasketTotalValue(itemsForCalculation)

                        return {
                            ...singleBasket,
                            basketItems: newBasketItems,
                            netValue: totals.totalNet,
                            grossValue: totals.totalGross,
                            taxValue: totals.totalTax
                        }
                    }
                    return singleBasket
                })
            })

            setInitialSavedBasket(prevInitial => {
                const newBasketItems = prevInitial.basketItems.filter(
                    basketItem => basketItem.artNo !== item.artNo
                )
                const itemsForCalculation = newBasketItems.map(bi => {
                    const realCostNet = Number(bi.costNet) || bi.product?.priceNet || 0
                    let realTaxRate = bi.product?.taxRate || 0

                    if (realTaxRate == 0 && bi.product?.priceGross > 0 && bi.product?.priceNet > 0) {
                        realTaxRate = (bi.product.priceGross / bi.product.priceNet) - 1
                    }

                    return {
                        ...bi,
                        costNet: realCostNet,
                        product: { ...bi.product, taxRate: realTaxRate }
                    }
                })
                const totals = getBasketTotalValue(itemsForCalculation)
                return {
                    ...prevInitial,
                    basketItems: newBasketItems,
                    netValue: totals.totalNet,
                    grossValue: totals.totalGross,
                    taxValue: totals.totalTax
                }
            })
        }
        else {
            toast.error('Błąd w trakcie usuwania pozycji z szybkokoszyka!')
        }
    }

    const handleProductQtyChange = (e, item) => {
        if (!handleOnChangeForQtyAndValueInput(e, item.decimalPlaces)) {
            e.preventDefault()
            return
        }
        const rawValue = e.target.value === '' ? 0 : e.target.value
        const newQty = parseFloat(rawValue)

        setSavedBaskets(prevSavedBaskets => {
            return prevSavedBaskets.map(singleBasket => {
                if (singleBasket.basketId === basket.basketId) {
                    const newBasketItems = singleBasket.basketItems.map(basketItem => {
                        if (basketItem.artNo === item.artNo) {
                            const newTotalCost = basketItem.costNet * newQty
                            const newTotalCostGross = basketItem.costGross * newQty
                            return {
                                ...basketItem,
                                qty: newQty,
                                totalCost: newTotalCost,
                                totalCostGross: newTotalCostGross,
                            }
                        }
                        return basketItem
                    })
                    return {
                        ...singleBasket,
                        basketItems: newBasketItems,
                    }
                }
                return singleBasket
            })
        })
    }

    const handleAddProductClick = () => {
        setSelectedSavedBasket(basket)
        navigate('/shop')
    }

    const productItemsSection = <tr>
        <td colSpan='9' style={{ padding: 5 }}>
            <div className='table-responsive table-items'  >
                <table className='table table-bordered'>
                    <thead>
                        <tr>
                            <th style={{ alignContent: 'center', verticalAlign: 'middle', fontWeight: 'normal', width: '10%' }}>Indeks</th>
                            <th style={{ alignContent: 'center', verticalAlign: 'middle', fontWeight: 'normal', width: 'auto' }}>Nazwa <br /> Cecha</th>
                            <th style={{ alignContent: 'center', verticalAlign: 'middle', fontWeight: 'normal', textAlign: 'right', width: '12%' }}>Cena netto PLN</th>
                            <th style={{ alignContent: 'center', verticalAlign: 'middle', fontWeight: 'normal', textAlign: 'right', width: '5%' }}>Ilość</th>
                            <th style={{ alignContent: 'center', verticalAlign: 'middle', fontWeight: 'normal', width: '3%' }}>Jedn.</th>
                            <th style={{ alignContent: 'center', verticalAlign: 'middle', fontWeight: 'normal', textAlign: 'right', width: '14%' }}>Wartość netto PLN</th>
                            <th style={{ alignContent: 'center', verticalAlign: 'middle', fontWeight: 'normal', textAlign: 'right', width: '2%', cursor: 'pointer' }}>
                                {isEditMode ?
                                    (<FaCheck size={20} color='var(--success-color)' onClick={() => handleSaveChanges(false)} />)
                                    :
                                    (<FaRegEdit size={20} onClick={() => setIsEditMode(true)} />)
                                }
                            </th>
                            {isEditMode &&
                                <th style={{ alignContent: 'center', verticalAlign: 'middle', fontWeight: 'normal', textAlign: 'right', width: '2%', cursor: 'pointer' }}>
                                    <RxCross2 size={20} color='var(--error-color)' onClick={() => handleSaveChanges(true)} />
                                </th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {basket.basketItems.map((item, key) => (
                            <tr className='hoverable-row' key={key}>
                                <td style={{ alignContent: 'center', verticalAlign: 'middle' }}>{getProductIndexWithMask(item.artNo)}</td>
                                <td style={{ alignContent: 'center', verticalAlign: 'middle' }}>{CapitalizeFirstLowercaseRest(item.product.title)} <br /> {CapitalizeFirstLowercaseRest(item.product.label)}</td>
                                <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>{ConvertPriceToString(item.product.priceNet, null)}</td>
                                <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>
                                    {isEditMode ?
                                        (<input type='number' className='biggerArrows offer-request-input' style={{ width: '100px' }} min={0} max={9999} value={item.qty}
                                            onFocus={(e) => handleInputForQtyAndValueFocus(e)} onChange={(e) => handleProductQtyChange(e, item)} />)
                                        :
                                        (item.qty)
                                    }
                                </td>
                                <td style={{ alignContent: 'center', verticalAlign: 'middle' }}>{item.product.baseUnit}</td>
                                <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>{ConvertPriceToString(item.totalCost, null)}</td>
                                {isEditMode ? (<td />) : (null)}
                                {isEditMode ? (<td style={{ textAlign: 'right', verticalAlign: 'middle' }}>
                                    <RxCross2 size={20} cursor={'pointer'} color='var(--error-color)' onClick={() => handleDeleteProductFromSavedBasket(item)} />
                                </td>) : (null)}
                            </tr>
                        ))}
                        {isEditMode && <tr>
                            <td colSpan='3'>
                                <div style={{ backgroundColor: 'transparent' }}>
                                    <button className='btn-app-secondary' onClick={handleAddProductClick}>Dodaj produkt</button>
                                </div>
                            </td>
                        </tr>}
                    </tbody>
                </table>
            </div>
        </td>
    </tr>

    useEffect(() => {
        setIsChecked(isCheckedParam)
    }, [isCheckedParam])

    const handleEditClick = async (e, save) => {
        e.stopPropagation()
        setIsBasketNameEdit(prev => !prev)
        if (save) {
            let res = await changeSavedBasketName(basket.basketId, basketName)
            if (!res) {
                toast.error('Błąd w trakcie aktualizacji nazwy szybkokoszyka')
            }
        }
    }

    return (<>
        <tr className="align-middle border-bottom element-pointer" id={basket.basketId} onClick={() => setShowBasketItems(prev => !prev)}>
            <td onClick={(e) => e.stopPropagation()}>
                <div onClickCapture={(e) => {
                    if (isEditMode) {
                        e.stopPropagation()
                        e.preventDefault()
                        toast.warning('Nie możesz wybrać edytowanego szybkokoszyka!')
                    }
                }}>
                    <CheckBox
                        className="custom-checkbox"
                        value={isChecked}
                        onValueChange={() => {
                            setIsChecked(prev => !prev)
                            handleCheckUncheckBasket(basket, !isChecked)
                        }}
                    />
                </div>
            </td>
            <td>{basket.lp}</td>
            <td>
                <div className='d-flex align-items-center'>
                    {isBasketNameEdit ?
                        (<>
                            <input type='text' className='offer-request-input' value={basketName} onFocus={handleInputForQtyAndValueFocus} onChange={(e) => { setBasketName(e.target.value) }} />
                            <FaCheck className='ms-2 element-pointer' color='var(--success-color)' onClick={(e) => handleEditClick(e, true)} />
                        </>)
                        :
                        (<>
                            <span>{basketName}</span>
                            <FaRegEdit className='ms-2 element-pointer' onClick={(e) => handleEditClick(e, false)} />
                        </>)}
                </div>
            </td>
            <td style={{ textAlign: 'right' }}>{basket.basketItems.length}</td>
            <td style={{ textAlign: 'right' }}>{ConvertPriceToString(basket.netValue, null)}</td>
            <td><IoCartOutline size={25} cursor={'pointer'} color='var(--primary)' onClick={(e) => {
                e.stopPropagation()
                setMessageModalFunctionTyp({ name: 'AddToCart', param: basket.basketId })
                if (cartItems && cartItems.basketItems && cartItems.basketItems.length > 0) {
                    setShowQuestionAboutReplaceBasket(true)
                }
                else {
                    let messageModalFunctionType = { name: 'AddToCart', param: basket.basketId } //przekazujemy, ponieważ setMessageModalFunctionTyp nie zdąrzy zmienic stanu :(
                    handleMessageModalResult('No', messageModalFunctionType)
                }
            }} /></td>
            <td><RxCross2 size={25} cursor={'pointer'} color='var(--error-color)' onClick={(e) => handleDeleteSavedBasketFunc(e, basket.basketId, basket.name)} /></td>
        </tr>
        {showBasketItems && !isBasketNameEdit &&
            productItemsSection
        }
    </>)
}

export default SavedBasketTabTableContent